export default function hasAnalyticsConsent() {
  return ( window.Termly?.getConsentState()?.analytics === true )
}
